module.exports = __webpack_public_path__ + "img/placeholder-portrait.65a1adea.png";